import moment from 'moment';
import { CohortTimelinePageState, ErrorMessageType } from './types';
import { ReduxAction } from '../../../../ReduxStorage/actions';
import {
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE_START,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE_FAILED,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE,
} from '../../../../ReduxStorage/Cohorts/actions';
import { AutoSaveState } from '../../../components/AutoSaveIndicator/component';

export const INITIAL_STATE: CohortTimelinePageState = {
  errorMessage: null,
  utcoffset: moment().format('Z'),
  autoSaveStates: {
    enrolmentCloseDate: AutoSaveState.Normal,
  },
};

export const COHORT_TIMELINE_UPDATE_START = 'COHORT_TIMELINE_UPDATE_START';
export const COHORT_TIMELINE_UPDATE_FALED = 'COHORT_TIMELINE_UPDATE_FALED';
export const UPDATE_COHORT_ADMIN_TIMELINE_UTCOFFSET =
  'UPDATE_COHORT_ADMIN_TIMELINE_UTCOFFSET';

export const UPDATE_COHORT_STARTDATE = 'UPDATE_COHORT_STARTDATE';
export const UPDATE_COHORT_ENDDATE = 'UPDATE_COHORT_ENDDATE';
export const SET_COHORT_SCHEDULED_MODE = 'SET_COHORT_SCHEDULED_MODE';
export const SET_COHORT_OPEN_MODE = 'SET_COHORT_OPEN_MODE';
export const SET_COHORT_SELF_PACED_MODE = 'SET_COHORT_SELF_PACED_MODE';
export const UPDATE_COHORT_SELF_PACED = 'UPDATE_COHORT_SELF_PACED';

export type UpdateCohortTimelinePageStateStart = {
  type: 'COHORT_TIMELINE_UPDATE_START';
};
export type UpdateCohortTimelinePageStateFailed = {
  type: 'COHORT_TIMELINE_UPDATE_FALED';
  errorMessage: ErrorMessageType;
};
export type UpdateCohortTimelinePageUtcoffset = {
  type: 'UPDATE_COHORT_ADMIN_TIMELINE_UTCOFFSET';
  utcoffset: string;
};

export type UpdateCohortStartDate = {
  type: 'UPDATE_COHORT_STARTDATE';
  cohortPath: string;
  startDate: moment.Moment | null;
};

export type UpdateCohortEndDate = {
  type: 'UPDATE_COHORT_ENDDATE';
  cohortPath: string;
  endDate: moment.Moment | null;
};

export type SetCohortScheduledMode = {
  type: 'SET_COHORT_SCHEDULED_MODE';
  cohortPath: string;
};

export type SetCohortOpenMode = {
  type: 'SET_COHORT_OPEN_MODE';
  cohortPath: string;
};

export type SetCohortSelfPacedMode = {
  type: 'SET_COHORT_SELF_PACED_MODE';
  cohortPath: string;
};
export type UpdateCohortSelfPaced = {
  type: 'UPDATE_COHORT_SELF_PACED';
  cohortPath: string;
  isSelfPaced: boolean;
};

export type UpdateCohortEnrolmentCloseDate = {
  type: 'UPDATE_COHORT_ENROLMENT_CLOSE_DATE';
  cohortPath: string;
  enrolmentCloseDate: string;
};

export type UpdateCohortEnrolmentCloseDateStart = {
  type: 'UPDATE_COHORT_ENROLMENT_CLOSE_DATE_START';
};

export type UpdateCohortEnrolmentCloseDateFailed = {
  type: 'UPDATE_COHORT_ENROLMENT_CLOSE_DATE_FAILED';
  errorMessage: ErrorMessageType;
};

export type CohortTimelinePageAction =
  | UpdateCohortTimelinePageStateStart
  | UpdateCohortTimelinePageStateFailed
  | UpdateCohortTimelinePageUtcoffset
  | UpdateCohortStartDate
  | UpdateCohortEndDate
  | SetCohortScheduledMode
  | SetCohortOpenMode
  | SetCohortSelfPacedMode
  | UpdateCohortSelfPaced
  | UpdateCohortEnrolmentCloseDate
  | UpdateCohortEnrolmentCloseDateStart
  | UpdateCohortEnrolmentCloseDateFailed;

export const CohortTimelinePageStateReducer = (
  state: CohortTimelinePageState = INITIAL_STATE,
  action: ReduxAction
): CohortTimelinePageState => {
  switch (action.type) {
    case COHORT_TIMELINE_UPDATE_START:
      return {
        ...state,
        errorMessage: null,
      };
    case COHORT_TIMELINE_UPDATE_FALED:
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case UPDATE_COHORT_ADMIN_TIMELINE_UTCOFFSET:
      return {
        ...state,
        utcoffset: action.utcoffset,
      };
    case UPDATE_COHORT_ENROLMENT_CLOSE_DATE_START:
      return {
        ...state,
        autoSaveStates: {
          ...state.autoSaveStates,
          enrolmentCloseDate: AutoSaveState.Saving,
        },
      };
    case UPDATE_COHORT_ENROLMENT_CLOSE_DATE:
      return {
        ...state,
        autoSaveStates: {
          ...state.autoSaveStates,
          enrolmentCloseDate: AutoSaveState.Saved,
        },
      };
    case UPDATE_COHORT_ENROLMENT_CLOSE_DATE_FAILED:
      return {
        ...state,
        autoSaveStates: {
          ...state.autoSaveStates,
          enrolmentCloseDate: AutoSaveState.Normal,
        },
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
